// RateCard API
import queryString from 'query-string'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RegionSecondLevel,
    ProductTypeCQuote,
} from 'app/enums/label.enums'
import {
    RateCardsData,
    StandardBaseLeaseFilterRequestResponse,
} from './RateCard.types'

type RateCardRequests = {
    getLogisticDetails: RequestConfigFunction<{
        originRegion: RegionSecondLevel,
        destinationRegion: RegionSecondLevel,
        productType: ProductTypeCQuote
    }, RateCardsData>,
    regionalServiceAvailabilityFilterRequest: RequestConfigFunction<Record<string, any>>,
    regionalServiceAvailabilityBulkEdit: RequestConfigFunction<{ data?: Record<string, any> }>,
    regionalServiceAvailabilityFilterCount: RequestConfigFunction<{ fieldName: string }>,
    otherLaneFeesFilterRequest: RequestConfigFunction<Record<string, any>>,
    otherLaneFeesBulkEdit: RequestConfigFunction<{ data?: Record<string, any> }>,
    otherLaneFeesFilterCount: RequestConfigFunction<{ fieldName: string }>,
    marginsFilterRequest: RequestConfigFunction<Record<string, any>>,
    marginsBulkEdit: RequestConfigFunction<{ data?: Record<string, any> }>,
    logisticsCostsFilterRequest: RequestConfigFunction<Record<string, any>>,
    logisticsCostsBulkEdit: RequestConfigFunction<{ data?: Record<string, any> }>,
    baseLeaseFilterRequest: RequestConfigFunction<Record<string, any>,
        StandardBaseLeaseFilterRequestResponse>,
    baseLeaseFilterCount: RequestConfigFunction<{ fieldName: string }>,
    baseLeaseBulkEdit: RequestConfigFunction<{ data?: Record<string, any> }>,
    embargoCountriesFilterRequest: RequestConfigFunction<undefined>,
    embargoCountriesGetCountryEmbargo: RequestConfigFunction<{ countryId: number }>,
    additionalFeesFilterRequest: RequestConfigFunction<Record<string, any>>,
    additionalFeesFilterCount: RequestConfigFunction<{ fieldName: string }>,
    additionalFeesBulkEdit: RequestConfigFunction<{ data?: Record<string, any> }>,
}

const rateCardRequests: RateCardRequests = {
    getLogisticDetails: (params) => {
        return {
            url: 'ratecard/logistics-details',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    regionalServiceAvailabilityFilterRequest: (params = {}) => {
        return {
            url: 'regionalserviceavailabilityratecard/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    regionalServiceAvailabilityFilterCount: ({
        fieldName,
    }: {
        fieldName: string
    }) => {
        return {
            url: `additionalfeeratecard/filter-request/all/count/${fieldName}`,
            method: 'POST',
            data: {
                rangeType: '',
            },
        }
    },
    regionalServiceAvailabilityBulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'regionalserviceavailabilityratecard/bulk',
            method: 'PATCH',
            data,
        }
    },
    otherLaneFeesFilterRequest: (params = {}) => {
        return {
            url: 'lanefeeratecard/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    otherLaneFeesBulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'lanefeeratecard/bulk',
            method: 'PATCH',
            data,
        }
    },
    otherLaneFeesFilterCount: ({
        fieldName,
    }) => {
        return {
            url: `lanefeeratecard/filter-request/all/count/${fieldName}`,
            method: 'POST',
            data: {
                rangeType: '',
            },
        }
    },
    marginsFilterRequest: (params = {}) => {
        return {
            url: 'marginratecard/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    marginsBulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'marginratecard/bulk',
            method: 'PATCH',
            data,
        }
    },
    logisticsCostsFilterRequest: (params = {}) => {
        return {
            url: 'logisticscostsratecard/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    logisticsCostsBulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'logisticscostsratecard/bulk',
            method: 'PATCH',
            data,
        }
    },
    baseLeaseFilterRequest: (params = {}) => {
        return {
            url: 'baseleaseratecard/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    baseLeaseFilterCount: ({
        fieldName,
    }) => {
        return {
            url: `baseleaseratecard/filter-request/all/count/${fieldName}`,
            method: 'POST',
            data: {
                rangeType: '',
            },
        }
    },
    baseLeaseBulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'baseleaseratecard/bulk',
            method: 'PATCH',
            data,
        }
    },
    embargoCountriesFilterRequest: () => {
        return {
            url: 'embargocountryratecard/filter-request/all',
            method: 'POST', // Not used, getEmbargoCountriesConfig() uses the URL only
        }
    },
    embargoCountriesGetCountryEmbargo: ({
        countryId,
    }) => {
        return {
            url: queryString.stringifyUrl({
                url: 'embargocountryratecard/countryembargoed',
                query: {
                    countryId,
                },
            }),
            method: 'GET',
        }
    },
    additionalFeesFilterRequest: (params = {}) => {
        return {
            url: 'additionalfeeratecard/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    additionalFeesFilterCount: ({
        fieldName,
    }) => {
        return {
            url: `additionalfeeratecard/filter-request/all/count/${fieldName}`,
            method: 'POST',
            data: {
                rangeType: '',
            },
        }
    },
    additionalFeesBulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'additionalfeeratecard/bulk',
            method: 'PATCH',
            data,
        }
    },
}

export default rateCardRequests
